import React from "react";
import ReactFC from "react-fusioncharts";
import FusionCharts from "fusioncharts";
import Column2D from "fusioncharts/fusioncharts.charts";
import FusionTheme from "fusioncharts/themes/fusioncharts.theme.fusion";
import { licenseKey } from "./license";
import ExcelExport from "fusioncharts/fusioncharts.excelexport";

ExcelExport(FusionCharts);

ReactFC.fcRoot(FusionCharts, Column2D, FusionTheme);

(FusionCharts as any).options["license"]({
  key: licenseKey,
  creditLabel: false,
});

interface BSCFinancialsChartProps {
  onRender: any;
  categories: {
    category: {
      label: string;
    }[];
  }[];
  dataset: {
    seriesName: string;
    data: {
      value: string;
    }[];
  }[];
}

class BSCFinancialsChart extends React.Component<BSCFinancialsChartProps> {
  render() {
    const { categories, dataset, onRender } = this.props;
    const baseChartConfig = {
      exportEnabled: "1",
      exportMode: "client",
      exportFormats: "PDF",
      theme: "fusion",
      divLineColor: "#d8d8d8",
      setAdaptiveYMin: "0",
      formatNumberScale: "0",
      xAxisNameFontColor: "#000000",
      showYAxisLine: "1",
      legendItemFontColor: "#000000",
      yAxisLineColor: "#d8d8d8",
      yAxisLineThickness: "1",
      showXAxisLine: "1",
      xAxisLineColor: "#000000",
      xAxisName: "Bank Classes",
      interactiveLegend: dataset.length > 1 ? "1" : "0",
      xAxisLineThickness: "1",
      labelFontColor: "#000000",
      labelFontSize: 20,
      yAxisValueFontColor: "#000000",
      paletteColors:
        "#003256,#00908C,#A48923,#C8326C,#20509E,#B7AC83,#38B8FF,#CCE9E8,#DE84A7,#f9c433",
      showToolTip: "1",
      plotToolText: "$seriesName: $dataValue",
      animation: "0",
    };

    const chartConfigs = {
      type: "stackedcolumn2d",
      renderAt: "chart-container",
      width: "100%",
      height: "50%",
      dataFormat: "json",
      dataSource: {
        chart: baseChartConfig,
        categories: categories,
        dataset: dataset,
      },
    };

    return (
      // @ts-ignore
      <ReactFC {...chartConfigs} onRender={onRender} id="fib-fin-chart" />
    );
  }
}

export default BSCFinancialsChart;
